import gql from "graphql-tag";
const getFilteredGenoplotsamples = gql(` 
query getFilteredGenoplotsamples($group: String!, $sample: String!) {
  getFilteredGenoplotsamples(group: $group, sample: $sample) {
      coords
      coords2
  } 
}   
`)
export default getFilteredGenoplotsamples
